import { Component } from '@angular/core';
import { NavigationHelperService } from './modules/core/services/navigation-helper/navigation-helper.service';
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
  // providers: [TimelineViewsService, TimelineMonthService, ResizeService, DragAndDropService]
})
export class AppComponent {

  constructor(public navigationHelper: NavigationHelperService){}
  title = 'faculty';

  ngOnInit() {
    this.navigationHelper.initialize();
}
}
